export default {"src":"/uk/_next/static/media/spot-laptop-compare.66c346a1.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};